/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import {Manager} from './Manager';
import {Role} from './Role';

export const PERMISSION_READ = '1';
export const PERMISSION_WRITE = '2';
export const PERMISSION_CREATE = '4';
export const PERMISSION_DELETE = '8';
export const PERMISSION_ADMINISTRATE = '16';

export class Permission {
  managers: Manager[];
  managersRoles: Role[];
  permissions: Map<number, string>;
  basePermission: Map<number, string>;
  myPermissions: string[];

  constructor(data: Permission = null) {
    if (Permission) {
      Object.assign(this, data);
    }
  }

  get write(): boolean {
    return this.myPermissions && this.myPermissions?.indexOf(PERMISSION_WRITE) !== -1;
  }

  get create(): boolean {
    return this.myPermissions && this.myPermissions?.indexOf(PERMISSION_CREATE) !== -1;
  }

  get delete(): boolean {
    return this.myPermissions && this.myPermissions?.indexOf(PERMISSION_DELETE) !== -1;
  }

  get administration(): boolean {
    return this.myPermissions && this.myPermissions?.indexOf(PERMISSION_ADMINISTRATE) !== -1;
  }

}
